"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const icon = {
  left: _icons.ArrowLeftThin,
  right: _icons.ArrowRightThin
};

/**
 * Simple arrows for scrolling inside tabs on desktop. Using slightly modified css styles.
 */
const Arrow = props => {
  const {
    direction,
    onClick,
    disabled
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const Icon = icon[direction];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ArrowRoot, {
    "aria-label": direction === 'left' ? '←' : '→',
    role: "button",
    tabIndex: -1,
    disabled: disabled ?? true,
    "data-testid": getTestId('arrow'),
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      fontSize: "inherit",
      height: 24
    })
  });
};
exports.Arrow = Arrow;
//# sourceMappingURL=Arrow.js.map